export default {
  Title: 'Users',
  Action: 'Create new user',
  UserStatus: 'User status: ',
  Filter: {
    Status: 'Status',
    StatusOptions: {
      ACTIVE: 'Active',
      INACTIVE: 'Inactive',
    },
    Role: 'Role',
    RoleOptions: {
      ADMIN: 'Admin',
      CAREGIVER: 'Caregiver',
    },
  },
  Card: {
    UserStatus: 'Status: #{status}',
    Status: {
      ACTIVE: 'Active',
      INACTIVE: 'Inactive',
    },
    Role: 'Role: #{status}',
    RoleOptions: {
      ADMIN: 'Admin',
      CAREGIVER: 'Caregiver',
    },
    Email: 'Email: #{email}',
    Action: {
      Deactivate: 'Deactivate',
    },
  },
};
